import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import FirmalarPage from './pages/FirmalarPage';
import FirmaDetayPage from './pages/FirmaDetayPage';
import KurumlarPage from './pages/KurumlarPage';
import AyarlarPage from './pages/AyarlarPage';
import AuditLogPage from './pages/AuditLogPage';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "'Outfit', sans-serif",
              fontSize: '14px',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(30,58,95,0.15)',
              border: '1px solid #C8D1E5',
            },
            success: { iconTheme: { primary: '#1E3A5F', secondary: '#fff' } },
          }}
        />
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="firmalar" element={<FirmalarPage />} />
            <Route path="firmalar/:id" element={<FirmaDetayPage />} />
            <Route path="kurumlar" element={<KurumlarPage />} />
            <Route path="ayarlar" element={<AyarlarPage />} />
            <Route path="audit-log" element={<AuditLogPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
